import {RecordForm} from '../forms/RecordForm';
import {useParams} from 'react-router-dom';
import {useSubscriptionItem} from '../hooks/useSubscriptionItem.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";
import {moduleConfig} from "../config";


export const AddPage = () => {
    const {id: subscriptionId} = useParams();
    
    const {
        record,
        createRecord,
    } = useSubscriptionItem(subscriptionId || '');

    return (
        <FormPageLayout
            title={`Add ${moduleConfig.titles.singular}`}
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={record || {} as any} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
